import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "button", "chevron"]

  connect() {
    this.isOpen = false
    this.outsideClickHandler = this.handleOutsideClick.bind(this)
    this.escapeHandler = this.handleEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
    document.removeEventListener("keydown", this.escapeHandler)
  }

  toggle(event) {
    event.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.isOpen = true
    this.menuTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.add("rotate-180")
    }
    document.addEventListener("click", this.outsideClickHandler)
    document.addEventListener("keydown", this.escapeHandler)
  }

  close() {
    this.isOpen = false
    this.menuTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.remove("rotate-180")
    }
    document.removeEventListener("click", this.outsideClickHandler)
    document.removeEventListener("keydown", this.escapeHandler)
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
